export default __webpack_public_path__ + "static/media/blog_grid_7.43e199fd.jpg";